import { ElementType, forwardRef } from 'react';
import { ButtonProps } from './type';
import { css, cx } from '@mildang/styled-system/css';
import { button } from '@mildang/styled-system/recipes';
import Link from 'next/link';
import { splitCssProps } from '@mildang/styled-system/jsx';
import { getButtonCompoundClassName } from './buttonCompoundStyles';

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  <C extends ElementType = 'button'>(props: ButtonProps<C>, ref: any) => {
    const {
      children,
      color = 'primary',
      component,
      className,
      disabled = false,
      endIcon,
      fullWidth = false,
      size = 'medium',
      startIcon,
      type = 'button',
      variant = 'text',
      selected = false,
      strong = false,
      loading = false,
      target,
      href,
      panda,
      ...other
    } = props;

    const [cssProps] = splitCssProps(other);
    const { ...styleProps } = cssProps;
    // @ts-ignore - 레거시 size 값("medium" 등)과 신규 recipe("md" 등) 타입 불일치
    const classes = button({ size, color, variant, strong, selected, fullWidth });
    const defaultElement = href ? Link : 'button';
    const Root: React.ElementType = component ?? defaultElement;

    const tagAttribute: {
      target?: string;
      href?: string;
      type?: string;
      disabled?: boolean;
      ['data-disabled']?: boolean;
    } = href ? { target, href } : { type, disabled };

    if (href && disabled) {
      tagAttribute['data-disabled'] = true;
    }

    return (
      <Root
        ref={ref}
        className={cx(
          classes.root,
          getButtonCompoundClassName({ size, color, variant, strong, selected }),
          css(styleProps, panda),
          className,
        )}
        data-has-start-icon={!!startIcon}
        data-has-end-icon={!!endIcon}
        {...tagAttribute}
        {...other}
      >
        {startIcon && <span className={cx(classes.icon, classes.startIcon)}>{startIcon}</span>}
        {children}
        {endIcon && <span className={cx(classes.icon, classes.endIcon)}>{endIcon}</span>}
      </Root>
    );
  },
);

export default Button;
